import { render, staticRenderFns } from "./Skor.vue?vue&type=template&id=b4dcd4fa&"
import script from "./Skor.vue?vue&type=script&lang=js&"
export * from "./Skor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports